export const filterItems = () => {
    // Check if the function has already been initialized to prevent double execution
    if (window.vdxFiltersInitialized) return;
    window.vdxFiltersInitialized = true;

    const forms = document.querySelectorAll("[vdx-filters-form]");
    if (forms.length === 0) return;
    const form = forms[0];

    // Parent container for all items that will be filtered
    const itemsContainer = document.querySelector("[vdx-filters-items]");
    if (!itemsContainer) return;

    // Treat all direct children of the container as filterable items
    const listItems = Array.from(itemsContainer.children);
    if (listItems.length === 0) return;

    const formInputs = form.querySelectorAll("input");
    const checkboxes = Array.from(formInputs).filter(input => input.type === "checkbox");
    const radios = Array.from(formInputs).filter(input => input.type === "radio");

    // If there are no checkbox or radio filters, do nothing (matches previous behavior)
    if (!checkboxes.length && !radios.length) return;

    const search = form.querySelector("[vdx-filters-search]");

    const getActiveCheckboxLabels = () => {
        return checkboxes
            .filter(cb => cb.checked)
            .map(cb => (cb.nextElementSibling?.textContent || "").trim())
            .filter(Boolean);
    };

    const getActiveRadioLabel = () => {
        const activeRadio = radios.find(radio => radio.checked);
        if (!activeRadio) return null;
        return (activeRadio.nextElementSibling?.textContent || "").trim() || null;
    };

    const applyFilters = () => {
        const activeCheckboxLabels = getActiveCheckboxLabels().map(label => label.toLowerCase());
        const activeRadioLabel = getActiveRadioLabel();
        const activeRadioLabelLower = activeRadioLabel ? activeRadioLabel.toLowerCase() : null;
        const searchValue = search ? search.value.trim().toLowerCase() : "";

        listItems.forEach(listItem => {
            const text = (listItem.textContent || "").toLowerCase();

            const matchesCheckboxes =
                activeCheckboxLabels.length === 0 ||
                activeCheckboxLabels.some(label => text.includes(label));

            const matchesRadio =
                !activeRadioLabelLower ||
                text.includes(activeRadioLabelLower);

            const matchesSearch =
                searchValue === "" ||
                text.includes(searchValue);

            const shouldShow = matchesCheckboxes && matchesRadio && matchesSearch;
            listItem.style.display = shouldShow ? "block" : "none";
        });
    };

    // Checkbox behavior
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", event => {
            const target = event.target;
            const labelEl = target.closest("label");
            if (labelEl) {
                if (target.checked) {
                    labelEl.classList.add("vdx--checked");
                } else {
                    labelEl.classList.remove("vdx--checked");
                }
            }
            applyFilters();
        });
    });

    // Radio behavior
    radios.forEach(radio => {
        radio.addEventListener("change", event => {
            const target = event.target;

            // Update visual state for all radios
            radios.forEach(r => {
                const labelEl = r.closest("label");
                if (!labelEl) return;
                if (r === target && r.checked) {
                    labelEl.classList.add("vdx--checked");
                } else {
                    labelEl.classList.remove("vdx--checked");
                }
            });

            applyFilters();
        });
    });

    // Search behavior (debounced)
    if (search) {
        let searchTimer;
        search.addEventListener("input", () => {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => {
                applyFilters();
            }, 500);
        });
    }

    // Apply filters once on initialization to ensure correct initial state
    applyFilters();
};